import styled from "styled-components";
import Row from "../../Shared/Kit/Row";
import Col from "../../Shared/Kit/Col";
import { HexToRgba } from "../../Methods/HexToRgba";

export const ChartContainer = styled(Row)`
    align-items: flex-start;
    margin-top: 40px;
    > div:nth-child(2) {
        border-right: 1px solid ${(props) => HexToRgba(props.theme.gray, 0.1)};
        border-left: 1px solid ${(props) => HexToRgba(props.theme.gray, 0.1)};
    }
`
export const Item = styled(Col)`
    position: relative;
    margin-bottom: 15px;
    &:last-child {
        margin-bottom: 0;
    }
    .btn {
        width: 200px;
        padding: 9px;
        background-color: ${(props) => HexToRgba(props.theme.gray, 0.05)};
        border-radius: 4px;
        font-size: ${(props) => props.theme.fontSizeSm};
        color: ${(props) => props.theme.gray};
        cursor: pointer;
        transition: all 300ms;
        &.active {
            background-color: ${(props) => props.theme.gray};
            color: ${(props) => props.theme.white};
        }
    }
    svg {
        position: absolute;
        left: -9px;
        width: 18px;
        height: 18px;
        fill: ${(props) => props.theme.secondary};
    }
`
